import React from 'react';
import { DropDown } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';

import Styles from './index.module.scss';

type WidgetDropDownPropsType = React.ComponentProps<typeof DropDown> & {
	label?: string;
	icon?: React.ReactNode;
};

const WidgetDropDown: React.FC<WidgetDropDownPropsType> = ({
	label,
	icon,
	items,
	...props
}) => {
	const { t } = useTranslation();
	const newItems = items.map((el:any)=>{
		return { label: t(el.label), value: el.value}
	})
	return(
		<DropDown items={newItems} {...props}>
			<div className={Styles.dropDownTrigger} style={{...props?.style}}>
				{label?t(label):undefined}
				{icon}
			</div>
		</DropDown>
	)
};

export default WidgetDropDown;
